import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { ProjectId } from 'api/models';
import { RootState } from 'data/index';
import { Task } from 'data/tasks';
import { useProjectTasksQuery } from 'queries/task';
import { selectTasksByProjectIdSelector } from '../selectors';

/**
 *
 * @deprecated Use `TasksStore.ofId`
 */
export const useTasksByIds = (
  projectId: ProjectId,
  taskIds: number[],
): Task[] => {
  const memoized = useMemo(selectTasksByProjectIdSelector, []);

  return useSelector((state: RootState) => memoized(state, taskIds));
};

export const useTasksByIdsFromRQ = (
  projectId: ProjectId,
  taskIds: number[],
) => {
  const { data: tasks, isLoading, ...query } = useProjectTasksQuery(projectId);

  const memoized = useMemo(
    () =>
      tasks
        ? tasks
            ?.filter((e) => taskIds?.includes?.(e?.taskId))
            .sort(
              (a, b) => taskIds.indexOf(a?.taskId) - taskIds.indexOf(b?.taskId),
            )
            ?.map(
              (d) =>
                ({
                  ...d,
                  project: d?.project?.projectId,
                  subTasks: d?.subTasks?.map((e) => e?.taskId),
                  // dependentTasks: d?.dependentTasks?.map((e) => e?.taskId),
                } as unknown as Task),
            )
        : ([] as Task[]),
    [taskIds, tasks],
  );

  return { tasks: memoized, isLoading, data: memoized, ...query };
};
